/**
 * @description 下载
 * @param {{blob:Blob,fileName:String}} options blob:文件数据 fileName:文件名
 * @return {void}
 */
export function download({blob, fileName}) {
    let downloadElement = document.createElement("a");
    // 创建下载的链接
    let href = (window.URL || window.webkitURL).createObjectURL(blob);
    downloadElement.href = href;
    // 下载后文件名
    downloadElement.download = fileName;
    document.body.appendChild(downloadElement);
    // 点击下载
    downloadElement.click();
    // 下载完成移除元素
    document.body.removeChild(downloadElement);
    // 释放掉blob对象
    (window.URL || window.webkitURL).revokeObjectURL(href);
}
